import Vue from 'vue'
import {Main, Loading, Slider, Submenu, Menu, MenuItem, MenuItemGroup, Divider, Scrollbar, Link, Dropdown,
  DropdownItem, DropdownMenu, Table, TableColumn, Col, Row, Form, FormItem, Option, Input, Select, Button,
  Popover, Tag, Image, Tabs, TabPane, Tooltip, Backtop, Autocomplete} from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(Main)
Vue.use(Slider)
Vue.use(Submenu)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)
Vue.use(Divider)
Vue.use(Scrollbar)
Vue.use(Link)
Vue.use(Dropdown)
Vue.use(DropdownItem)
Vue.use(DropdownMenu)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Col)
Vue.use(Row)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Option)
Vue.use(Input)
Vue.use(Select)
Vue.use(Button)
Vue.use(Popover)
Vue.use(Tag)
Vue.use(Image)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Tooltip)
Vue.use(Backtop)
Vue.use(Autocomplete)

Vue.use(Loading.directive)

Vue.prototype.$loading = Loading.service



// WEBPACK FOOTER //
// ./src/plugins/element.js